<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <div
        data-show="true"
        role="document"
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    (click)="closeDialog()"
                    class="close">
                    <i class="nlrp-icon nlrp-icon-close"></i
                ></button>
                <h4 class="modal-title">{{title}}</h4>
            </div>
            <div class="modal-body">
                <div class="container-fluid well">
                    <div class="row">
                        <div class="col-xs-1">
                            <i class="nlrp-icon nlrp-icon-warning nlrp-36 alertImageFormat"> </i>
                        </div>
                        <div class="col-xs-11">
                            <p class="alertMessageFormat"> {{message}} </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-default nlr-btn-sm"
                    (click)="save()"
                    >Save
                </button>
                <button
                    type="button"
                    class="btn btn-default nlr-btn-sm"
                    (click)="cancelSave()"
                    >Don't Save
                </button>
                <button
                    type="button"
                    class="btn btn-default nlr-btn-sm"
                    (click)="closeDialog()"
                    >Cancel
                </button>
            </div>
        </div>
    </div>
</div>
